export const CONTENT_MODERATION_PATH = "/apps/content-moderation";

export const REVIEW_QUEUE_PATH = `${CONTENT_MODERATION_PATH}/review-queue`;

export const REPORTED_CONTENT_PATH = `${CONTENT_MODERATION_PATH}/reported`;
